import { createSlice } from "@reduxjs/toolkit";

export const projectDetails = createSlice({
  name: "projectDetails",
  initialState: {
    selectedRow: null,
    rowDetailsOpen: false,
  },
  reducers: {
    onRowSelect: (state, action) => {
      state.selectedRow = action.payload;
    },
    onRowDeselect: (state) => {
      state.selectedRow = null;
      state.rowDetailsOpen = false;
    },
    toggle: (state) => {
      state.rowDetailsOpen = !state.rowDetailsOpen;
    },
  },
});

export const selectors = {
  getState: (state) => state.projectDetails,
};
